<template>
  <div
    v-if="workflow"
    ref="modal"
    id="agWfMetadata"
    :key="`reload-${reload}`"
    centered
    no-close-on-esc
    no-close-on-backdrop
  >
    <b-input-group size="md" prepend="Name">
      <b-input
        type="text"
        v-model="workflow.name"
        autocomplete="false"
        :disabled="disableUI"
      ></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Notes">
      <b-form-textarea
        type="text"
        v-model="workflow.notes"
        rows="1"
        maxRows="10"
        no-resize
        :disabled="disableUI"
      >
      </b-form-textarea>
    </b-input-group>
    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Start Date:</label>
      <datetime
        v-model="workflow.schedule.startDate"
        type="datetime"
        format="M/dd/yy"
        :phrases="{ ok: 'Set', cancel: 'Cancel' }"
        :state="hasError('startDate')"
        :disabled="disableUI"
      ></datetime>
      <b-button
        class="agTextButton agInputGroup-append"
        :disabled="disableUI"
        @click="clearStartDateButton_click"
        >Clear</b-button
      >
    </div>
    <div class="agInputGroup agInputGroupCentered">
        <b-form-checkbox
          v-model="workflow.syncronous"
          :disabled="disableUI"
          >Syncronous</b-form-checkbox
        >
    </div>
    <div v-if="workflow.schedule.days" class="agInputGroup">
      <label>Days:</label>
      <div id="agWfMetadata-days" class="agInputGroup agInputSubGroup">
        <b-form-checkbox
          v-model="workflow.schedule.days[1]"
          :disabled="disableUI"
          >Monday</b-form-checkbox
        >
        <b-form-checkbox
          v-model="workflow.schedule.days[2]"
          :disabled="disableUI"
          >Tuesday</b-form-checkbox
        >
        <b-form-checkbox
          v-model="workflow.schedule.days[3]"
          :disabled="disableUI"
          >Wednesday</b-form-checkbox
        >
        <b-form-checkbox
          v-model="workflow.schedule.days[4]"
          :disabled="disableUI"
          >Thursday</b-form-checkbox
        >
        <b-form-checkbox
          v-model="workflow.schedule.days[5]"
          :disabled="disableUI"
          >Friday</b-form-checkbox
        >
        <b-form-checkbox
          v-model="workflow.schedule.days[6]"
          :disabled="disableUI"
          >Saturday</b-form-checkbox
        >
        <b-form-checkbox
          v-model="workflow.schedule.days[0]"
          :disabled="disableUI"
          >Sunday</b-form-checkbox
        >
      </div>
      <b-button
        id="agWfMetadata-selectSelectAllDays"
        class="agTextButton"
        :disabled="disableUI"
        @click="selectSelectAllDays"
        >Select/Unselect All</b-button
      >
    </div>
    <div class="agInputGroup agInputGroupCentered">
      <label>Start Time:</label>
      <datetime
        v-model="workflow.schedule.startTime"
        type="time"
        format="HH:mm"
        :state="hasError('startTime')"
        :disabled="disableUI"
      ></datetime>
      <b-button
        class="agTextButton agInputGroup-append"
        :disabled="disableUI"
        @click="clearStartTimeButton_click"
        >Clear</b-button
      >
    </div>
    <div class="agInputGroup agInputGroupCentered">
      <label>End Time:</label>
      <datetime
        v-model="workflow.schedule.endTime"
        type="time"
        format="HH:mm"
        :state="hasError('endTime')"
        :disabled="disableUI"
      >
      </datetime>
      <b-button
        class="agTextButton agInputGroup-append"
        :disabled="disableUI"
        @click="clearEndTimeButton_click"
        >Clear</b-button
      >
    </div>
    <div class="agInputGroup agInputGroupCentered">
      <label>Frequency:</label>
      <b-form-input
        v-model="workflow.schedule.frequency"
        min="1"
        type="number"
        :disabled="disableUI"
      ></b-form-input>
      <span class="agInputGroup-append">minutes</span>
    </div>
    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Email Summary:</label>
      <b-input-group>
        <b-input-group-prepend is-text>
          <b-form-checkbox
            v-model="workflow.sendEmail"
            switch
            class="mr-n2">
            <span class="sr-only">Enable Email Summary</span>
          </b-form-checkbox>
        </b-input-group-prepend>
        <b-form-input
          v-model="workflow.email"
          aria-label="Email for summary to be sent to"
        ></b-form-input>
      </b-input-group>
    </div>
    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Log Level:</label>
      <b-form-select
        class="agMediumInput"
        v-model="workflow.logLevel"
        :options="logOptions"
        :disabled="disableUI"
      >
      </b-form-select>
    </div>
    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{
        modalMessage
      }}</label>
    </div>
    <div
      v-if="showLaunchButton"
      :style="{ 'text-align': 'center', 'margin-top': '25px' }"
    >
      <b-button variant="primary" @click="launchEditorButton_click"
        >Launch Editor</b-button
      >
    </div>
  </div>
</template>


<script>
// components

// modules
import Util from "src/util/util";
import Moment from "moment";
import { Datetime } from "vue-datetime";

export default {
  name: "ag-workflow-metadata",
  components: {
    datetime: Datetime,
  },
  props: {
    workflow: Object,
    isReadonly: Boolean,
    showLaunchButton: Boolean,
  },
  data() {
    return {
      reload: 0,
      modalMessage: "",
      modalMessageClass: "",
      frequencyTypes: [
        { value: "minutes", text: "Minutes" },
        { value: "days", text: "Days" },
        { value: "weekday", text: "Day of the Week" },
      ],
      logOptions: [
        { value: 0, text: "None" },
        { value: 1, text: "Error" },
        { value: 2, text: "Warn" },
        { value: 3, text: "Info" },
        { value: 4, text: "Debug" },
        { value: 5, text: "Breakpoint" },
      ],
    };
  },

  computed: {
    disableUI() {
      if (this.isReadonly || this.isLoading) return true;
      return false;
    },

    workflows() {
      return this.$store.state.wfStore.workflows;
    },
  },

  methods: {
    // UI Events

    clearStartDateButton_click() {
      this.workflow.schedule.startDate = "";
    },

    clearStartTimeButton_click() {
      this.workflow.schedule.startTime = "";
    },

    clearEndTimeButton_click() {
      this.workflow.schedule.endTime = "";
    },

    async launchEditorButton_click() {
      this.$emit("launchWorkflowEditor");
    },

    selectSelectAllDays() {
      if (this.workflow.schedule.days.indexOf(false) != -1) {
        this.workflow.schedule.days = [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
        ];
      } else {
        this.workflow.schedule.days = [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ];
      }
    },

    // other

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
    },

    hasError(field) {
      if (field == this.errorField) {
        return false; // false = error
      }
      return null;
    },

    validate() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      let startDate = new Date(this.workflow.schedule.startDate);
      let startTime = new Date(this.workflow.schedule.startTime);
      let endTime = new Date(this.workflow.schedule.endTime);
      this.workflow.schedule.frequency = parseInt(
        this.workflow.schedule.frequency
      );

      // check name
      if (this.workflow.name.length == 0) {
        this.errorField = "name";
        this.modalMessage = "Name is required";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }

      var sameNameWf = this.workflows.find((a) => a.name == this.workflow.name);
      if (
        sameNameWf &&
        (!this.workflow._id || sameNameWf._id != this.workflow._id)
      ) {
        this.errorField = "name";
        this.modalMessage =
          'A workflow named "' +
          this.workflow.name +
          '" already exists in this workspace';
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }

      // check start date
      if (isNaN(startDate.getTime())) {
        this.errorField = "startDate";
        this.modalMessage = "Start date is required";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }

      // check start and end times
      if (isNaN(startDate.getTime())) {
        this.errorField = "startDate";
        this.modalMessage = "Start date is required";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }
      if (isNaN(startTime.getTime())) {
        this.errorField = "startTime";
        this.modalMessage = "Start time must contain a valid time.";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }
      if (isNaN(endTime.getTime())) {
        this.errorField = "endTime";
        this.modalMessage = "End time must contain a valid time.";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }
      if (endTime.getTime() - startTime.getTime() <= 0) {
        this.errorField = "endTime";
        this.modalMessage = "End time must be after start time.";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }

      // check frequency
      if (this.workflow.schedule.frequency < 1) {
        this.errorField = "frequency";
        this.modalMessage = "Frequency must be greater than or equal to 1";
        this.modalMessageClass = "agModal-errorMessage";
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped lang="css">
#agWfMetadata-days {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 500px;
  margin: auto;
  overflow: hidden;
  text-align: center;
}

#agWfMetadata-days div {
  text-align: left;
  margin: 5px;
}

#agWfMetadata-selectSelectAllDays {
  display: block;
  margin: auto;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/workflow/WorkflowMetadata.vue